import {
  SHAREABLE_COLUMNS,
  SharedCapTableSettings,
} from '../../../hooks/shared-cap-table/shared-cap-table.types';
import { Column, DetailsSortVariant } from '../../../types/snapshot.types';

/**
 * Every column the owner can switch, in one list. The payload carries the union of both views and
 * the viewer flips between them at will, so a per-view list would publish columns — the three that
 * belong to a single view — with no switch anywhere on screen.
 */
export const ALL_SHAREABLE_COLUMNS: Column[] = [
  ...SHAREABLE_COLUMNS[DetailsSortVariant.BY_STAKEHOLDER],
  ...SHAREABLE_COLUMNS[DetailsSortVariant.BY_SHARE_CLASS].filter(
    (column) => !SHAREABLE_COLUMNS[DetailsSortVariant.BY_STAKEHOLDER].includes(column),
  ),
];

export const isColumnShared = (
  columns: SharedCapTableSettings['columns'],
  column: Column,
): boolean => Object.values(DetailsSortVariant).some((view) => columns[view].includes(column));

/**
 * One switch now governs a column everywhere it can appear, so the two stored selections cannot
 * drift apart. A column belonging to a single view is written only there.
 */
export const toggleSharedColumn = (
  columns: SharedCapTableSettings['columns'],
  column: Column,
): SharedCapTableSettings['columns'] => {
  const shouldShare = !isColumnShared(columns, column);

  return Object.values(DetailsSortVariant).reduce(
    (acc, view) => {
      if (!SHAREABLE_COLUMNS[view].includes(column)) {
        return acc;
      }

      return {
        ...acc,
        [view]: shouldShare
          ? [...acc[view].filter((current) => current !== column), column]
          : acc[view].filter((current) => current !== column),
      };
    },
    { ...columns },
  );
};
